import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    message: null,
    error: null,
    loading: false,
    status: null,
    searchCode: [],
    loading_null: false,
    editStatus_null: null,
    message_null: null,
    editNullValues: {},
    loginLogs: [],
    allUserEmails: [],
    allUserProfiles: [],
    allProfiles: [],
};

const insertFormSuccess = (state, action) => {
    return updateObject(state, {
        message: action.message,
        loading: false,
        status: action.status
    });
};

const insertFormFail = (state, action) => {
    return updateObject(state, {
        message: action.message,
        loading: false,
        status: action.status
    });
};

const insertFormRemoveMessage = (state, action) => {
    return updateObject(state, {
        message: null,
        loading: false,
        status: null
    });
};

const fetchSearchCodeSuccess = (state, action) => {
    return updateObject(state, {
        searchCode: action.searchCode
    });
};

const fetchAdminNullValuesStart = (state, action) => {
    return updateObject(state, { loading_null: true });
};

const fetchAdminNullValuesSuccess = (state, action) => {
    return updateObject(state, {
        editNullValues: action.editNullValues,
        editStatus_null: action.editStatus_null,
        loading_null: false
    });
};

const fetchAdminNullValuesFail = (state, action) => {
    return updateObject(state, {
        message_null: action.message_null,
        editStatus_null: action.editStatus_null,
        loading_null: false
    });
};

const adminNullValuesRemoveMessage = (state, action) => {
    return updateObject(state, {
        message_null: null,
        editStatus_null: null
    });
};

const loginLogsSuccess = (state, action) => {
    return updateObject(state, {
        loginLogs: action.loginLogs
    });
};

const fetchAllUserProfilesSuccess = (state, action) => {
    return updateObject(state, {
        allUserProfiles: action.allUserProfiles
    })
};

const fetchAllUserEmailsSuccess = (state, action) =>{
    return updateObject(state,{
        allUserEmails: action.allUserEmails
    })
};

const fetchAllProfilesSuccess = (state, action) => {
    return updateObject(state, {
        allProfiles: action.allProfiles
    })
};


const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.INSERT_FORM_SUCCESS: return insertFormSuccess(state, action);
        case actionTypes.INSERT_FORM_FAIL: return insertFormFail(state, action);
        case actionTypes.FETCH_SEARCHCODE_SUCCESS: return fetchSearchCodeSuccess(state, action);
        case actionTypes.FETCH_ADMIN_FORM_NULL_VALUES_START: return fetchAdminNullValuesStart(state, action);
        case actionTypes.FETCH_ADMIN_FORM_NULL_VALUES_SUCCESS: return fetchAdminNullValuesSuccess(state, action);
        case actionTypes.FETCH_ADMIN_FORM_NULL_VALUES_FAIL: return fetchAdminNullValuesFail(state, action);
        case actionTypes.ADMIN_FORM_NULL_REMOVE_MESSAGE: return adminNullValuesRemoveMessage(state, action);
        case actionTypes.FETCH_LOGIN_LOGS_SUCCESS: return loginLogsSuccess(state, action);
        case actionTypes.REMOVE_MESSAGE_INSERT_FORM: return insertFormRemoveMessage(state, action);
        case actionTypes.FETCH_ALL_USER_PROFILES_SUCCESS: return fetchAllUserProfilesSuccess(state, action);
        case actionTypes.FETCH_ALL_USER_EMAILS_SUCCESS: return fetchAllUserEmailsSuccess(state, action);
        case actionTypes.FETCH_ALL_PROFILES_SUCCESS: return fetchAllProfilesSuccess(state, action);
        default:
            return state
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/admin.js